export default __webpack_public_path__ + "static/media/SWT1350.34I-35727_-20841_0.e4ead018.jpg";